import styled, { css } from 'styled-components';

type StyleProps = {
  color?:
    | 'transparent'
    | 'grey'
    | 'white'
    | 'black'
    | 'blue'
    | 'green'
    | 'yellow'
    | 'red'
    | 'brand'
    | 'purple'
    | 'common'
    | 'set'
    | 'glow'
    | 'fire';
  size?: 'compact' | 'small' | 'medium' | 'large';
  brand?: boolean;
};

// https://www.figma.com/design/SFAfhEiMKvudU66FU9MB8G/Components?node-id=1983-5582&node-type=frame&m=dev
export const Chip = styled.span<StyleProps>`
  flex-shrink: 0;
  display: inline-flex;
  gap: var(--half-unit);
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-align: center;
  border-radius: 16px;

  ${({ color = 'transparent' }) => {
    switch (color) {
      case 'grey':
        return css`
          background: var(--c-nl-200);
          color: var(--c-black);
        `;
      case 'black':
        return css`
          background: var(--c-black);
          color: var(--c-white);
        `;
      case 'white':
        return css`
          background: var(--c-white);
          color: var(--c-black);
        `;
      case 'blue':
        return css`
          background: rgba(var(--c-rgb-blue-300), 0.16);
          color: var(--c-blue-300);
        `;
      case 'green':
        return css`
          background: var(--c-surface-success);
          color: var(--c-onBase-success);
        `;
      case 'yellow':
        return css`
          background: var(--c-surface-caution);
          color: var(--c-yellow-400);
        `;
      case 'red':
        return css`
          background: var(--c-red-400);
          color: var(--c-white);
        `;
      case 'brand':
        return css`
          background: var(--c-gradient-mix);
          color: var(--c-white);
        `;
      case 'purple':
        return css`
          background: var(--c-rewards-squad);
          color: var(--c-white);
        `;
      case 'common':
        return css`
          background: var(--c-gradient-common);
          color: var(--c-black);
        `;
      case 'glow':
        return css`
          background: var(--c-gradient-conversionCreditBorder);
          color: var(--c-black);
        `;
      case 'set':
        return css`
          color: var(--c-black);
          background-color: var(--set-color, var(--c-nd-600-opaque));
        `;
      case 'fire':
        return css`
          background: linear-gradient(323.24deg, #fef314 -3.1%, #ff4e22 52.7%);
          color: var(--c-black);
        `;
      case 'transparent':
      default:
        return css`
          background: var(--c-nd-50);
          color: var(--c-white);
          backdrop-filter: blur(32px);
        `;
    }
  }}
  ${({ size = 'small' }) => {
    switch (size) {
      case 'large':
        return css`
          min-height: 32px;
          padding: 6px var(--intermediate-unit);
          font: var(--t-label-l);
          font-weight: var(--t-bold);
        `;
      case 'medium':
        return css`
          min-height: 24px;
          padding: var(--half-unit) var(--unit);
          font: var(--t-label-m);
          font-weight: var(--t-bold);
        `;
      case 'compact':
        return css`
          min-height: 12px;
          padding: 1px var(--half-unit);
          font: var(--t-label-xs);
          font-weight: var(--t-bold);
        `;
      case 'small':
      default:
        return css`
          min-height: var(--chip-small-height);
          padding: 2px var(--unit);
          font: var(--t-label-s);
          font-weight: var(--t-bold);
        `;
    }
  }}
  ${({ brand }) =>
    brand &&
    css`
      font-family: var(--brand-font);
      text-transform: uppercase;
    `}
`;
